export const DISPLAY_NAME_ALERT = "OrionPageAlert";
export const DISPLAY_NAME_PAGE = "OrionPage";
export const DISPLAY_NAME_SIDEBAR = "OrionSidebar";
export const DISPLAY_NAME_MAIN = "OrionPageMain";
export const DISPLAY_NAME_HEADER = "OrionPageHeader";
export const DISPLAY_NAME_FOOTER = "OrionPageFooter";
export const DISPLAY_NAME_BREADCRUMB = "OrionBreadcrumb";
export const DISPLAY_NAME_TITLE = "OrionPageHeaderTitle";
export const DISPLAY_NAME_TITLE_TEXT = "OrionPageHeaderTitleText";
export const DISPLAY_NAME_ACTIONS = "OrionPageHeaderActions";
export const DISPLAY_NAME_BODY = "OrionPageBody";
export const DISPLAY_NAME_TABS = "OrionPageTabs";
